import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box, Card, CardContent, Typography, Stack, Checkbox } from '@mui/material';

import { GridToolbar, plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';

import { formatDateTime } from '../../../../../services/functions';

export default function Notifications ({ formik }) {

  const columns = [
    { field: 'created_at', headerName: 'Data', flex: 0.5, valueGetter: params => formatDateTime(params.row.created_at) },
    { field: 'pl_type_name', headerName: 'Typ Powiadomienia', flex: 0.8 },
    { field: 'addressee', headerName: 'Adresat', flex: 0.4 },
    { field: 'title', headerName: 'Tytuł Powiadomienia', flex: 0.8 },
    { field: 'message_hidden', headerName: 'Wycinek Treści', flex: 1.2 },
    { field: 'sender', headerName: 'Użytkownik', flex: 0.4 }
  ];

  return (
    <Stack style={{ height: '100%' }}>
      <Card>
        <CardContent>
          <Stack direction="column" justifyContent="space-between">
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
              <Checkbox id="automatic_notifications" name="automatic_notifications" checked={formik.values.automatic_notifications} onChange={formik.handleChange}/>
              <Typography variant="subtitle2">Powiadomienia automatyczne</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} flex="1 1 20%">
              <Checkbox id="manual_notifications" name="manual_notifications" checked={formik.values.manual_notifications} onChange={formik.handleChange} />
              <Typography variant="subtitle2">Powiadomienia ręczne</Typography>
            </Stack>
          </Stack>
          <Box height={40}/>
          <DataGridPro
            autoHeight
            rows={formik.values.notifications}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            pagination
            components={{ Toolbar: GridToolbar }}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          />
        </CardContent>
      </Card>
    </Stack>
  );
}
